export const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_id',
  'utm_term',
  'utm_content',
  'utm_source_platform',
  'utm_creative_format',
  'utm_marketing_tactic',
] as const;

export const CLICK_ID_KEYS = [
  'gclid',
  'gbraid',
  'wbraid',
  'dclid',
  'gclsrc',
  'gad_source',
  'gad_campaignid',
  'fbclid',
  'li_fat_id',
  'msclkid',
  'ttclid',
] as const;

export const AD_METADATA_KEYS = [
  'adgroup',
  'hsa_acc',
  'hsa_cam',
  'hsa_grp',
  'hsa_ad',
  'hsa_src',
  'hsa_tgt',
  'hsa_kw',
  'hsa_mt',
  'hsa_net',
  'hsa_ver',
  'campaign_id',
  'adset_id',
  'ad_id',
  'placement',
] as const;

export const ALL_ATTRIBUTION_KEYS = [...UTM_KEYS, ...CLICK_ID_KEYS, ...AD_METADATA_KEYS] as const;

export const SIGNUP_ATTRIBUTION_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'fbclid',
  'msclkid',
  'ttclid',
] as const;
